<template>
  <div class="data">
    <h2 class="client">我们的客户</h2>
    <!-- <div class="desc-box">
      <p class="desc">
        一匠科技始终坚持贯彻“匠心研发，倾力服务“经营理念，6年时间优秀作品研发超过800个，合作供应商规模达40家合作企业超过600家，其中包括中国中铁、中国石化、中国邮政、中国移动、丰顺旅游局等国内知名企业与社会机构
      </p>
    </div> -->
    <p></p>
    <ul class="data-list clearfix">
      <li>
        <img src="../../static/images/home/jingyan.png" />
        <h4>{{ one }}+开发经验</h4>
      </li>
      <li>
        <img src="../../static/images/home/tuandui.png" />
        <h4>{{ two }}+开发人员</h4>
      </li>
      <li>
        <img src="../../static/images/home/qiye.png" />
        <h4>服务{{ three }}+家企业</h4>
      </li>
      <li>
        <img src="../../static/images/home/chanpin.png" />
        <h4>{{ four }}+产品</h4>
      </li>
    </ul>
    <div class="desc">
      一匠科技始终坚持贯彻“匠心研发，倾力服务“经营理念，6年时间优秀作品研发超过800个，合作供应商规模达40家合作企业超过600家，其中包括中国中铁、中国石化、中国邮政、中国移动、丰顺旅游局等国内知名企业与社会机构
    </div>
  </div>
</template>

<script>
export default {
  name: "Data",
  data() {
    return {
      one: 0,
      two: 0,
      three: 0,
      four: 0,
    };
  },
  mounted() {
    document.addEventListener("scroll", this.ChangeData, false);
  },
  methods: {
    ChangeData() {
      let num = document.body.scrollTop || document.documentElement.scrollTop;
      // console.log(num)
      if (num >= 350) {
        let one_timer = setInterval(() => {
          this.one++;
          if (this.one == 6) {
            clearInterval(one_timer);
          }
        }, 2000 / 5);
        let two_timer = setInterval(() => {
          this.two++;
          if (this.two == 50) {
            clearInterval(two_timer);
          }
        }, 2000 / 40);
        let three_timer = setInterval(() => {
          this.three += 2;
          if (this.three == 600) {
            clearInterval(three_timer);
          }
        }, 3000 / 500);
        let four_timer = setInterval(() => {
          this.four += 2;
          if (this.four == 800) {
            clearInterval(four_timer);
          }
        }, 3000 / 500);
        document.removeEventListener("scroll", this.ChangeData, false);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.data {
  background: url('../../static/images/home/kehu_bg.png') no-repeat;
  background-size:7.5rem 4.3rem;
  width: 7.5rem;
  vertical-align: middle;
  margin: 0 auto;
  height: 4.3rem;
  padding: 0.38rem 0;
  box-sizing: border-box;
  position: relative;
  margin-bottom:100px;

  .desc {
    margin-left:12px;
    box-sizing:border-box;
    padding:19px 20px;
    width: 351px;
    height: 124px;
    text-align:center;
    background: #FFFFFF;
    box-shadow: 0px 2px 8px 0px rgba(111, 111, 111, 0.1);
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
  }

  .client {
    text-align: center;
    font-size: 0.44rem;
    font-weight: bold;
    color: #FFFFFF;
  }

  .desc-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    line-height: 30px;

    .desc {
      width: 720px;
      font-size: 18px;
      font-weight: 400;
      color: #FFFFFF;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
    }
  }

  .data-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 0 auto;
    box-sizing: border-box;

    .title {
      font-weight: 400;
      color: #FFC000;
      padding: 0 0 23px 43px;
    }

    li {
      float: left;
      width: 35%;
      margin-left: 5px;
      margin-bottom: 20px;
      text-align: center;

      h4 {
        color: #fff;
        font-size: 16px;
        letter-spacing: 1px;
        font-family: 'Rajdhani-Regular';
      }

      p {
        color: #ffffff;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        margin-top: 21px;
      }

      img {
        min-width: 24px;
        min-height: 24px;
        width: 24px;
        height: 24px;
        vertical-align: text-bottom;
        margin-bottom: 8px;
      }
    }

    li:last-of-type {
      padding-right: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/HomeData.vue